<div class="wrapper" *ngIf="isVisible">
  <sui-message class="{{ className }}" (dismiss)="onDismiss()">
    <p class="no-vertical-margin" *ngIf="message">
      <strong>{{ message }}</strong>
    </p>
  </sui-message>
</div>
